import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage, { decorateIntlMessages } from '../../../../common/rosetta_formatted_message';
import { Th } from '../../../../common/fa_icons';
import { defineMessages, injectIntl } from 'react-intl';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  see_all_slides: {
    id: 'see_all_slides',
    description: 'Call-to-action to open "See All Slides" view',
    defaultMessage: 'See All Slides'
  }
}));

export function SeeAllSlidesButton({ handleClick, intl }) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <a 
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      title={intl.formatMessage(i18nMessages.see_all_slides)}
      aria-label={intl.formatMessage(i18nMessages.see_all_slides)}
    >
      <div className="nav-left see-all-slides">
        <Th />
      </div>
      <div className="slide-info left">
        <div className="slide-info-text">
          <RosettaFormattedMessage parentFilename={__filename}
            id="see_all_slides"
            description='Call-to-action to open "See All Slides" view'
            defaultMessage="See All Slides"
          />
        </div>
      </div>
    </a>
  );
}

export default injectIntl(SeeAllSlidesButton);

SeeAllSlidesButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};
